import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { portalApi, apiError } from "@/lib/api";
import { usePortal } from "@/portal/PortalContext";
import { toast } from "@/components/ui/sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Phone, KeyRound, ArrowRight, Loader2 } from "lucide-react";

export default function PortalLogin() {
  const { login } = usePortal();
  const navigate = useNavigate();
  const [step, setStep] = useState("phone");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [devOtp, setDevOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const requestOtp = async () => {
    setLoading(true);
    try { const { data } = await portalApi.post("/portal/auth/request-otp", { phone }); setDevOtp(data.dev_otp || ""); setStep("otp"); toast.success(data.message); }
    catch (e) { toast.error(apiError(e)); } finally { setLoading(false); }
  };
  const verify = async () => {
    setLoading(true);
    try { const { data } = await portalApi.post("/portal/auth/verify-otp", { phone, code }); await login(data.token); navigate("/portal"); }
    catch (e) { toast.error(apiError(e)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-full bg-[#0B7C5A] flex items-center justify-center p-6" data-testid="portal-login">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-xl p-6 sm:p-8">
        <div className="flex items-center gap-2 mb-6">
          <img src="/tradedesk-mark.png" alt="TradeDesk360" className="w-9 h-9 object-contain" />
          <div><div className="font-bold text-lg text-[#101D51] leading-tight">Retailer Portal</div><div className="text-[11px] text-[#6B7189]">Order from your distributor · TradeDesk360</div></div>
        </div>
        <h2 className="text-xl font-bold text-[#101D51]">Sign in</h2>
        <p className="text-sm text-[#6B7189] mt-1 mb-5">{step === "phone" ? "Use the mobile number registered with your distributor." : `We sent a code to +91 ${phone}.`}</p>
        {step === "phone" ? (
          <div className="space-y-4">
            <div className="relative"><Phone className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#6B7189]" />
              <Input data-testid="portal-phone-input" value={phone} inputMode="numeric" onChange={(e) => setPhone(e.target.value)} placeholder="Mobile number" className="pl-9 h-11" onKeyDown={(e) => e.key === "Enter" && requestOtp()} /></div>
            <Button data-testid="portal-request-otp-btn" onClick={requestOtp} disabled={loading || phone.replace(/\D/g, "").length < 10} className="w-full h-11 bg-[#0B7C5A] hover:bg-[#09664a]">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Send OTP <ArrowRight className="w-4 h-4" /></>}</Button>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="relative"><KeyRound className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#6B7189]" />
              <Input data-testid="portal-otp-input" value={code} inputMode="numeric" maxLength={6} onChange={(e) => setCode(e.target.value)} placeholder="123456" className="pl-9 h-11 tracking-[0.4em] font-semibold" onKeyDown={(e) => e.key === "Enter" && verify()} /></div>
            {devOtp && <div className="text-xs bg-[#F5F6FA] border border-[#E6E8F0] rounded-lg px-3 py-2 text-[#6B7189]">Demo mode — your OTP is <span className="font-bold text-[#101D51]">{devOtp}</span></div>}
            <Button data-testid="portal-verify-btn" onClick={verify} disabled={loading || code.length < 4} className="w-full h-11 bg-[#101D51] hover:bg-[#080852]">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Verify & continue"}</Button>
            <button onClick={() => setStep("phone")} className="text-sm text-[#6B7189] hover:text-[#101D51] w-full text-center">Change number</button>
          </div>
        )}
        <div className="text-[11px] text-[#6B7189] mt-6 text-center">Distributor staff? <a href="/login" className="text-[#0B7C5A] font-medium">Sign in to TradeDesk360</a></div>
      </div>
    </div>
  );
}
